<template>
    <div class="setBackground">
        <CModal
            centered
            class="disable-footer backgroundColor disable-header "
            :show.sync="warningModal"
        >
            <CRow>
                <CCol>
                    <center><CImg :src="logo" class="logoImage" /></center>
                    <br /><br />
                    <center>
                        <h3>Connect Your wallet</h3>
                    </center>
                    <center>
                        <CCol sm="9" class="removePadding">
                            <CCard
                                class="cardForWallet"
                                @click="ConnectToWallet"
                            >
                                <CRow>
                                    <CCol sm="4">
                                        MetaMask
                                    </CCol>
                                    <CCol sm="5"></CCol>
                                    <CCol>
                                        <CImg
                                            :src="metaMaskLogo"
                                            class="imageIcon"
                                        />
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                    </center>
                    <center>
                        <CCol sm="9" class="removePadding">
                            <CCard
                                class="cardForWallet"
                                @click="ConnectToWallet"
                            >
                                <CRow>
                                    <CCol sm="5" class="startText">
                                        Wallet Connect
                                    </CCol>
                                    <CCol sm="4"></CCol>
                                    <CCol>
                                        <CImg
                                            :src="walletConnect"
                                            class="imageIcon"
                                        />
                                    </CCol>
                                </CRow>
                            </CCard>
                        </CCol>
                    </center>
                </CCol>
            </CRow>
        </CModal>

        <!-- <h1>Selected Account: {{ connectedAccount }}</h1> -->
    </div>
</template>

<script type="text/javascript">
import * as walletConnector from '../../services/wallet-connectivity-service';
import metaMaskLogo from '../../assets/images/metaMask.png';
import portis from '../../assets/images/portis.png';
import walletConnect from '../../assets/images/walletConnect.png';
import logo from '../../assets/images/logo.png';
import { storeData } from '../../store';

export default {
    data() {
        return {
            name: 'Vue.js',
            connectedAccount: '',
            accountObj: {},
            warningModal: true,
            metaMaskLogo,
            portis,
            walletConnect,
            logo
        };
    },
    methods: {
        async ConnectToWallet() {
            this.accountObj = await walletConnector.connectToWallet();
            // await tokenSwapService.initTokenSwap();
            this.connectedAccount = this.accountObj.selectedAccount;
            console.log(this.accountObj.accountBalance);
            storeData.walletBalance = this.accountObj.accountBalance;
            storeData.walletAddress = this.accountObj.selectedAccount;
            this.$router.push('/dashboard');
        }
    }
};
</script>

<style scoped>
.backgroundColor {
    background-color: #272f51 !important;
}
.removePadding {
    padding-bottom: 5px;
    padding-top: 5px;
}
.cardForWallet {
    border: none;
    display: flex;
    padding: 10px;
    cursor: pointer;
    margin-bottom: 0px;
    margin: 0px;
    background-color: #1e2442;
}
.setBackground {
    background-color: #272f51 !important;
}
.imageIcon {
    width: 25px;
    height: 25px;
}
.startText {
    align-content: flex-start;
}
.logoImage {
    width: 40%;
    padding: 20px;
}
</style>
